import { createStore } from 'vuex'
import userdata from './modules/userdata'
import preferences from './modules/preferences'
import appliances from './modules/appliances'
// import library from './modules/library'
import afterSales from './modules/afterSales'
import ai from './modules/ai'
// import createLogger from '../../../src/plugins/logger'

import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: (process.env.NODE_ENV !== 'production'? '':'rc4') , isCompression: false, encryptionSecret: 'irinox-s3cr3tPa$$w0rd@123' });

const debug = process.env.NODE_ENV !== 'production'

export const store = createStore({
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],
  modules: {
    userdata,
    preferences,
    appliances,
    // library,
    ai,
    afterSales,
  },
  strict: debug,
//   plugins: debug ? [createLogger()] : []
})
